// extracted by mini-css-extract-plugin
export default {"text":"HeaderText_text__0K7OU"};